import { SET_ACTIVE_LAYOUT } from "../types/actionResponseTypes";

export const setActiveLayout = (prop:string, datalayout: any) => ({ type: SET_ACTIVE_LAYOUT, payload: {prop, datalayout} });